import React from "react";
import FlightLegsContent from "../components/flightLegs/flightLegs-content";

const FlightLegs = () => {
  return <FlightLegsContent />;
};

export default FlightLegs;
